import { NavLink } from "react-router-dom";

function Footer() {
    return (
        <>
            <div className='footer'>
                <hr />
                <NavLink className="footer-nav-link" to={"/booking"}>Booking</NavLink>
                <NavLink className="footer-nav-link" to={"/resources"}>Resources</NavLink>
                <NavLink className="footer-nav-link" to={"/terms"}>Terms</NavLink>
                <p>&copy; 2024 Oberman Financial Coaching. All rights reserved</p>
            </div>

        </>
    );
}

export default Footer;